import { render, staticRenderFns } from "./EditPlaces.vue?vue&type=template&id=0dbd5b8a&scoped=true&"
import script from "./EditPlaces.vue?vue&type=script&lang=js&"
export * from "./EditPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbd5b8a",
  null
  
)

export default component.exports